<template>
  <div class="form-row lar_form_row">
    <slot />
  </div>
</template>
<script>
import '~style/components/form.scss'
export default {
  name: 'FormRow'
}
</script>
<style lang="scss" scoped>
.lar_form_row {
    .form_section_title {
        font-size: 20px;
        margin: 10px 0 25px;
        font-family: 'PingFangTC-Medium';
        font-weight: normal;
    }

}

</style>
